<ng-template #templateToast>
  <div [class]="'app-global-alert ' + currentAlertCssClass">
    <div class="app-global-alert__header">
      <div class="app-global-alert__header__left-column">
        <img class="app-global-alert__header__icon" [src]="currentAlertIconSrc" alt="alert" />

        <p class="app-global-alert__header__title">{{ this.currentGlobalAlert?.title }}</p>
      </div>
      <div class="app-global-alert__header__right-column">
        <div *ngIf="isMultipleAlerts" class="app-global-alert__steps-display">
          <div class="app-global-alert__steps-display__navigation">
            <img
              class="app-global-alert__steps-display__navigation__left-button"
              src="assets/icons/icon_chev_left.svg"
              alt="left"
              [ngClass]="{ disabled: isFirstAlert }"
              (click)="onNavigate('left')"
            />
            <img
              class="app-global-alert__steps-display__navigation__right-button"
              src="assets/icons/icon_chev_right.svg"
              alt="right"
              [ngClass]="{ disabled: isLastAlert }"
              (click)="onNavigate('right')"
            />
          </div>
          <span class="app-global-alert__steps-display__tag">
            {{ stepsDisplayCounter }}
          </span>
        </div>
      </div>
    </div>

    <div class="app-global-alert__body">
      <div class="app-global-alert__body__left-column">
        <p class="app-global-alert__body__text" *ngIf="isInnerText" [innerText]="this.currentGlobalAlert?.text"></p>
        <p class="app-global-alert__body__text" *ngIf="!isInnerText">{{ this.currentGlobalAlert?.text }}</p>
      </div>
      <div class="app-global-alert__body__right-column">
        <button class="app-global-alert__dismiss-button btn btn-link" (click)="onDismiss(this.currentGlobalAlert.id)">
          {{ "BUTTON.GOT_IT" | translate | uppercase }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
